import React from "react";
import { PenSquare, Trash2 } from "lucide-react";

import { Button } from "../../../components/ui/button";

interface Props {
  onEdit: () => void;
  onDelete: () => void;
  deleteDisabled?: boolean;
  deleteTitle?: string;
}

export default function ListActions({ onEdit, onDelete, deleteDisabled, deleteTitle }: Props) {
  return (
    <div className="flex justify-end gap-1">
      <Button variant="ghost" size="icon" aria-label="Editar" onClick={onEdit}>
        <PenSquare className="h-4 w-4" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        aria-label="Excluir"
        title={deleteTitle}
        className="text-destructive disabled:opacity-30"
        disabled={deleteDisabled}
        onClick={onDelete}
      >
        <Trash2 className="h-4 w-4" />
      </Button>
    </div>
  );
}
